import React, {
    // useContext,
    useEffect,
    useState,
} from 'react'
import { Redirect, useLocation } from 'react-router-dom'
// import AppContext from "app/appContext";
import useAuth from 'app/hooks/useAuth'

// const getUserRoleAuthStatus = (pathname, user, routes) => {
//   const matched = routes.find((r) => r.path === pathname);

//   const authenticated =
//     matched && matched.auth && matched.auth.length
//       ? matched.auth.includes(user.role)
//       : true;

//   return authenticated;
// };

const AuthGuard = ({ children, nextPath = '/' }) => {
    const {
        isAuthenticated,
        //  user
    } = useAuth()

    const [previouseRoute, setPreviousRoute] = useState(null)
    const { pathname } = useLocation()

    // const { routes } = useContext(AppContext);
    // const isUserRoleAuthenticated = getUserRoleAuthStatus(pathname, user, routes);
    // let authenticated = isAuthenticated && isUserRoleAuthenticated;

    // IF YOU NEED ROLE BASED AUTHENTICATION,
    // UNCOMMENT ABOVE TWO LINES, getUserRoleAuthStatus METHOD AND user VARIABLE
    // AND COMMENT OUT BELOW LINE
    let authenticated = isAuthenticated

    // useEffect(() => {

    // })

    // useEffect(() => {
    //     const checkLoggedIn = async () => {
    //         let token = localStorage.getItem('auth-token')
    //         if (token === null) {
    //             localStorage.setItem('auth-token', '')
    //             token = ''
    //         }
    //         const tokenResponse = await Axios.post(
    //             'http://localhost:5000/users/tokenIsValid',
    //             null,
    //             { headers: { 'x-auth-token': token } }
    //         )
    //         if (tokenResponse.data) {
    //             const userResponse = await Axios.get(
    //                 'http://localhost:5000/users/',
    //                 {
    //                     headers: { 'x-auth-token': token },
    //                 }
    //             )
    //             setUserData({
    //                 token,
    //                 user: userResponse.data,
    //             })
    //         }
    //     }

    //     checkLoggedIn()
    // }, [])

    useEffect(() => {
        if (previouseRoute !== null) setPreviousRoute(pathname)
    }, [pathname, previouseRoute])

    if (authenticated) return <>{children}</>
    else {
        return (
            <Redirect
                to={{
                    pathname: nextPath,
                    state: { redirectUrl: previouseRoute },
                }}
            />
        )
    }
}

export default AuthGuard
